import log from 'loglevel'
import React from 'react'
import { Button, ButtonState } from '../components/Button'

export function LoginPage() {
  const [status, setStatus] = React.useState<ButtonState>('idle')
  const [idp, setIdp] = React.useState(() => {
    const stored = window.localStorage.getItem('identity-provider')
    return stored ? JSON.parse(stored) : 'https://solidcommunity.net/'
  })

  React.useEffect(() => {
    window.localStorage.setItem('identity-provider', JSON.stringify(idp))
  }, [idp])

  function handleLogin() {
    setStatus('pending')
    const aggService = process.env.REACT_APP_AGGREGATION_SERVICE
    if (!aggService) {
      const msg = 'No environment variable set for AGGREGATION_SERVICE'
      log.error(msg)
      throw new Error(msg)
    }
    const path = '/surveys'
    const baseRoute = `${window.location.protocol}//${window.location.host}${path}`
    window.location.href = `${aggService}/login?oidcProvider=${idp}&redirectUrl=${encodeURIComponent(
      baseRoute
    )}`
  }

  return (
    <>
      <div className="text-center mb-4 font-extrabold tracking-tight">
        <h1 className="text-3xl text-gray-900 ">Survey Creator</h1>
        <h2 className="text-lg font-light text-gray-500">
          powered by Konsolidate
        </h2>
      </div>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg content-center ">
        <div className="inline-flex items-center w-full">
          <div className="px-4 py-5 sm:px-6 mx-auto">
            <Button loading={status === 'pending'} onClick={handleLogin}>
              Log in with Solid
            </Button>
          </div>
        </div>
        <div className="border-t border-gray-200 w-full flex flex-col">
          <div className="bg-gray-50 px-4 py-5 sm:px-6 flex flex-col">
            <label
              className="text-sm font-medium text-gray-500 pb-1"
              htmlFor="idp"
            >
              Identity Provider
            </label>
            <input
              className="border py-2 px-3 text-grey-darkest "
              id="idp"
              type="text"
              value={idp}
              disabled={status === 'pending'}
              onChange={event => setIdp(event.target.value)}
            />
            <div className="text-left text-xs font-light text-gray-400 pt-2">
              Try{' '}
              <button onClick={() => setIdp('https://inrupt.net/')}>
                https://inrupt.net/
              </button>{' '}
              or{' '}
              <button onClick={() => setIdp('https://solidcommunity.net/')}>
                https://solidcommunity.net/
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
